import { Calibra } from '../models/calibra';
import { CalibrationDocument } from '../models/calibrationDocument';
import { Device } from '../models/device';
import { ManufacturerDescription } from '../models/manufacturerDescription';
import { NumberListModel } from '../models/numberListModel';
import { Manufacturer } from '../models/manufacturer';

export class CalibraService {    
    
    public async SaveCalibra(calibra: Calibra): Promise<number> {
        const options: RequestInit = {
            method: "POST", 
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
            body:JSON.stringify(calibra)
       
        };

        const response = await fetch('/api/calibra/SaveCalibra', options)
        return response.json();
    }    

    public async GetCalibraById(calibraId: number): Promise<Calibra> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch('/api/calibra/GetCalibraById?calibraId='+calibraId, options)
        return response.json();
    }

    public async GetAllCalibras(): Promise<Calibra[]> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch('/api/calibra/GetAllCalibras')
        return response.json();
    }    

    public async GetCalibrationTypes(): Promise<Array<any>> {
        const options: RequestInit = {
            method: "GET",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch(`/api/calibra/GetCalibrationTypes`, options)
        return response.json();
    }

    public async UploadCalibrationDocument(formData:any, calibrationId: number, serialNumber: string): Promise<any> {        
        const requestHeaders: Headers = new Headers();		

		const httpClientOptions: any = {
			headers: requestHeaders,
			credentials: 'include',
			method: 'POST',
			body: formData
		};

        const response = await fetch(`/api/calibra/UploadCalibrationDocument?calibrationId=`+calibrationId+`&serialNumber=`+serialNumber, httpClientOptions)
        return response;
    }
    
    public async GetCalibrationDocumentsForDownloadPage(calibrationId: number): Promise<CalibrationDocument[]> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch(`/api/calibra/GetCalibrationDocumentsForDownloadPage?calibrationId=`+calibrationId)
        return response.json();
    } 
    public async GetCalibrationDocuments(calibrationId: number): Promise<CalibrationDocument[]> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch(`/api/calibra/GetCalibrationDocuments?calibrationId=`+calibrationId)
        return response.json();
    }  

    public async DeleteCalibrationDocumentById(calibrationDocumentId: number) {
        const options: RequestInit = {
            method: "POST", 
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
            body:JSON.stringify(calibrationDocumentId)       
        };

        const response = await fetch(`/api/calibra/DeleteCalibrationDocumentById?calibrationDocumentId=`+calibrationDocumentId, options)
        return response;
    }  

    public async DeleteCalibra(calibrationId: number) {
        const options: RequestInit = {
            method: "POST", 
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
            body:JSON.stringify(calibrationId)       
        };

        const response = await fetch(`/api/calibra/DeleteCalibra?calibrationId=`+calibrationId, options)
        return response;
    }  

    public async GetCalibrationDocumentById(calibrationDocumentId: number) {
        const options: RequestInit = {
            method: "GET",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",

        };

        window.open(`/api/calibra/GetCalibrationDocumentById?calibrationDocumentId=` + calibrationDocumentId ,'_blank')        
    }

    public async GetCalibrationHistories(calibrationId: number): Promise<any[]> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch(`/api/calibra/GetCalibrationHistories?calibrationId=`+calibrationId)
        return response.json();
    }  

    public async GetCalibrationDocumentsInZip(calibrationIds: string) {
        const options: RequestInit = {
            method: "GET",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
        };

        window.location.assign(`/api/calibra/GetCalibrationDocumentsInZip?calibrationIds=`+calibrationIds)        
    }  

    public async GetDeviceByQueryText(queryText: string, storeCode: string): Promise<Array<Device>> {
        const options: RequestInit = {
            method: "GET",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",

        };
        let query = queryText.replaceAll('#', '');
        let url = `/api/calibra/GetDeviceByQueryText?queryText=` + query + "&sapCode=" + storeCode;

        const response = await fetch(url, options)
        return response.json();
    }

    public async GetCalibrationDocumentsAnonymous(calibrationId: number) {
        const options: RequestInit = {
            method: "GET",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
        };
        const response = await fetch(`/api/documentdownload/GetCalibrationDocumentsAnonymous?calibrationId=`+calibrationId)

        return response.json();   
    } 

    public async GetManufacturerDescriptions(): Promise<ManufacturerDescription[]> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch('/api/calibra/GetManufacturerDescriptions')
        return response.json();
    } 

    public async SaveManufacturerDescription(manufacturerDescription: ManufacturerDescription): Promise<number> {
        const options: RequestInit = {
            method: "POST", 
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
            body:JSON.stringify(manufacturerDescription)
       
        };

        const response = await fetch('/api/calibra/SaveManufacturerDescription', options)
        return response.json();
    } 

    public async ExportCalibras(numberListModel: NumberListModel) {
        const options: RequestInit = {
            method: "POST", 
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
            body:JSON.stringify(numberListModel)
       
        };

        const response = await fetch("/api/calibra/ExportCalibras", options);

        if (!response.ok) {
            console.error("Export failed:", response.statusText);
            return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Calibra_Export.xlsx"; // or whatever filename you expect
        link.click();
        window.URL.revokeObjectURL(url); 
    } 

    public async GetCalibraDevices(queryText: string): Promise<any> {
        const options: RequestInit = {
            method: "GET",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",

        };
        let query = queryText.replaceAll('#', '');
        let url = `/api/calibra/GetCalibraDevices?queryText=` + query;

        const response = await fetch(url, options)
        return response.json();
    }

    public async GetManufacturerOptions(calibraId: number): Promise<Array<any>> {
        const options: RequestInit = {
            method: "GET",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch(`/api/calibra/GetManufacturerOptions?calibraId=`+calibraId, options)
        return response.json();
    }

    public async SaveManufacturer(manufacturer: Manufacturer): Promise<number> {
        const options: RequestInit = {
            method: "POST", 
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
            body:JSON.stringify(manufacturer)
       
        };

        const response = await fetch('/api/calibra/SaveManufacturer', options)
        return response.json();
    }    
    public async InactivateManufacturer(manufacturer: Manufacturer): Promise<number> {
        const options: RequestInit = {
            method: "POST", 
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include",
            body:JSON.stringify(manufacturer)
       
        };

        const response = await fetch('/api/calibra/InactivateManufacturer', options)
        return response.json();
    }    
    

    public async GetManufacturerById(manufacturerId: number): Promise<Manufacturer> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch('/api/calibra/GetManufacturerById?manufacturerId='+manufacturerId, options)
        return response.json();
    }

    public async GetManufacturers(): Promise<Array<any>> {
        const options: RequestInit = {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json" },
            credentials: "include"
        };

        const response = await fetch('/api/calibra/GetManufacturers')
        return response.json();
    }  
}